import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const EvolutionApiFormSchema = Yup.object().shape({
    phoneNumber: Yup.string().required('Preenchimento Obrigatório'),
    connected: Yup.boolean(),
});

export type TEvolutionApiConfigFormSchema = Yup.InferType<typeof EvolutionApiFormSchema>;

export const evolutionApiConfigFormSchemaDefaultValues: TEvolutionApiConfigFormSchema = {
    phoneNumber: '',
    connected: false,
};
